<script setup lang="ts">
import { required, email } from '@vuelidate/validators'
import type { VuelidateParserParams } from '~~/composables/useVuelidateParser'

const { auth } = useSupabaseClient()
const emit = defineEmits(['onSignupSuccess'])

const formFieldsDefinition: VuelidateParserParams = [
  { key: 'email', value: '', rules: { required, email } },
  { key: 'password', value: '', rules: { required } },
]

const handleSubmit = async (formData: any) => {
  const { error } = await auth.signUp({
    email: formData.email,
    password: formData.password,
    options: {
      emailRedirectTo: `${window.location.origin}/login/token`,
    },
  })
  if (error)
    throw (
      error?.toString()?.replace('AuthApiError:', '') ??
      'Invalid credentials provided.'
    )
}

const onSubmitSuccess = () => {
  successMessage.value = 'You registered successfully.'
  emit('onSignupSuccess')
}

const { v$, submitForm, canSubmit, successMessage } = useFormUtils({
  vuelidate: formFieldsDefinition,
  hooks: {
    onSubmit: handleSubmit,
    onSubmitSuccess: onSubmitSuccess,
  },
})
</script>
<template lang="pug">
form(@submit.prevent="submitForm" class="form-tight")
  UiInput(
    v-model="v$.email.$model"
    type="email"
    placeholder="Company Email"
    autocomplete="email"
    :error="v$.email.$errors[0]?.$message"
  )
  div(class="flex flex-col lg:flex-row gap-9")
    UiInput(
      v-model="v$.password.$model"
      type="password"
      placeholder="Password"
      autocomplete="new-password"
      :error="v$.password.$errors[0]?.$message"
    )
    button(
      class="btn btn-primary"
      type="submit"
      :disabled="!canSubmit"
    )
      span Submit
      MaterialSymbol arrow_right_alt
</template>
